module.exports = __webpack_public_path__ + "static/media/secret.84b37da9.jpg";